<div class="category-landing">
  <img class="landing-picture" src="/assets/PORTADA+MENU-MOVIL-7.jpg" alt="" />
  <div class="navigation-landing">
    <div class="item-text" [routerLink]="'/actor/actor-ficcion'">
      Actor Ficción
    </div>
    <div class="item-text" [routerLink]="'/actor/actor-marca'">
      Actor Marcas
    </div>
  </div>
</div>
